import React from 'react';
import { Menu } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { MenuState, useFeatureFlag } from 'modules/common/hooks';
import { isWithinAnotherApp } from 'containerApp';
import {
  MyRepliconItem,
  AboutDialog,
  AboutMenuItem,
  useAboutDialogState,
  FeedbackDialog,
  FeedbackMenuItem,
  useFeedbackDialogState,
  LogoutMenuItem,
  DownloadMenuItem,
  SettingsMenuItem,
  useSettingsDialogState,
  SettingsDialog
} from './items';

const useStyles = makeStyles((theme) => ({
  menuItem: {
    padding: theme.spacing(1.25, 8.75, 1.25, 2)
  },
  icon: {
    minWidth: theme.spacing(4.5)
  },
  repliconLogoNew: {
    width: theme.spacing(3.2)
  }
}));

const AppMenu: React.FC<MenuState> = ({ anchorEl, onMenuClose }: MenuState) => {
  const classes = useStyles();

  const isMenuFeedbackEnabled = useFeatureFlag('isMenuFeedbackEnabled');
  const isTiAutoAcceptUserSettingsEnabled = useFeatureFlag(
    'isTiAutoAcceptUserSettingsEnabled'
  );

  const [
    feedbackDialogOpen,
    openFeedbackDialog,
    closeFeedbackDialog
  ] = useFeedbackDialogState({ onMenuClose });

  const [
    aboutDialogOpen,
    openAboutDialog,
    closeAboutDialog
  ] = useAboutDialogState({ onMenuClose });

  const [
    settingsDialogOpen,
    openSettingsDialog,
    closeSettingsDialog
  ] = useSettingsDialogState({ onMenuClose });

  return (
    <>
      <Menu
        id="application-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={onMenuClose}
        anchorOrigin={{ vertical: 'center', horizontal: 'center' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MyRepliconItem classes={classes} onMenuClose={onMenuClose} />
        {isMenuFeedbackEnabled && (
          <FeedbackMenuItem classes={classes} onClick={openFeedbackDialog} />
        )}
        <AboutMenuItem classes={classes} onClick={openAboutDialog} />
        {!isWithinAnotherApp() && <DownloadMenuItem />}
        {isTiAutoAcceptUserSettingsEnabled && (
          <SettingsMenuItem classes={classes} onClick={openSettingsDialog} />
        )}

        <LogoutMenuItem classes={classes} onMenuClose={onMenuClose} />
      </Menu>
      <FeedbackDialog open={feedbackDialogOpen} onClose={closeFeedbackDialog} />
      <AboutDialog open={aboutDialogOpen} onClose={closeAboutDialog} />
      <SettingsDialog open={settingsDialogOpen} onClose={closeSettingsDialog} />
    </>
  );
};

export default AppMenu;
